module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADQSURBVEiJ7ZO/DYJAFIe/IwzBCIxgYeMIJl6iHUxgYUVh5R6GjuKGwIIhGIEdJDkLJSHmHXeFxITwK+/P9728dwdrFh8lLepjfiDiwtPujSm7KYDWWUKsDKjCVPfmez9yaM9YNsSq1jpLPPAa2IK9SWdkQW810AKpSzKCp0BLb09yrf7qBsBuaNfUXrDABQIIhXsFouSdIHiQQJAQCgfXkH+Y/7Zo1iHP+kxDAKESecixMr6LxpTdp2XDj68klOMVqQJ4+Po7kjSgrq5zaxaeF57smfWQjYjQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-upload/images/close.png
// module id = +rQ4
// module chunks = 4